import HelpDetails from 'src/components/common/HelpDetails/HelpDetails'

export const getBranchSpecification = (includedDraft: string, excludedDraft: string) =>
  [
    ...(includedDraft.length > 0
      ? includedDraft.split(',').map(branch => `+:refs/heads/(${branch})`)
      : ['+:refs/heads/*']),
    ...(excludedDraft.length > 0
      ? excludedDraft.split(',').map(branch => `-:refs/heads/(${branch})`)
      : []),
  ].join('\n')

export const includedBranchesLabel = (
  <>
    {'Included'}
    <HelpDetails>{'A comma-separated list of branches'}</HelpDetails>
  </>
)
export const excludedBranchesLabel = (
  <>
    {'Excluded'}
    <HelpDetails>{'A comma-separated list of branches'}</HelpDetails>
  </>
)
